import React from "react";
import { appHost } from "../../helpers/uri";

const PrintReceipt = ({ v }) => {
  const _show = () => {
    window.open(`${appHost}application-receipt/${v?._id}`, `Student Module Registration Window`, `_parent`, `width=450,height=650`);
  };
  return (
    <button onClick={_show} className="btn btn-info text-white float-right">
      Print Application Slip <i className="fa-solid fa-print"></i>
    </button>
  );
};

export default PrintReceipt;
